<template>
<video v-if="isMP4" width="500" height="280" :class="mainClass" autoplay loop muted>
  <source :src="imageSrc" type="video/mp4" />
  Your browser does not support the video tag.
</video>
<img v-else :src="imageSrc" :class="mainClass"/>
</template>

<script>
  import { EventBus } from '../EventBus.js'
  // import data from '../data'
  
  export default {
    mounted () {
      EventBus.$on('game-clicked', dat => {
        this.visible = true
        this.currentGame = dat['game']
      })
      EventBus.$on('game-unclicked', dat => {
        this.visible = false
        this.currentGame = {}
      })
    },
    computed: {
      mainClass () {
        return 'game_gif' + (this.visible ? ' visible' : '')
      },
      imageSrc () {
        if (this.currentGame != null) {
          if (this.currentGame.gif) {
            return this.currentGame.gif
          }
          return this.currentGame.img
        }
        return ''
      },
      isMP4 () {
        if (this.currentGame != null) {
          if (this.currentGame.gif) {
            return this.currentGame.gif.toLowerCase().endsWith('mp4')
          }
        }
        return false
      }
    },
    methods: {
      onClick () {
        // EventBus.$emit('game-unclicked', { game: this.game, left: rect.right > width / 2 })
        EventBus.$emit('game-unclicked', { game: this.currentGame })
      }
    },
    data () {
      return {
        visible: false,
        currentGame: {}
      }
    }
  }
</script>

<style>
.game_gif {
    position: fixed;
    width: 500px;
    height: 280px;
    right: 50%;
    top: 10%;
    z-index: -1;
    transition: all 100ms ease-in-out;
    opacity: 0;
    margin: 20px;
    border-radius: 10px 10px;
    border: 5px solid rgba(221, 90, 13, 1);
}
.game_gif.visible {
    z-index: 9999;
    opacity: 1.0;
}
</style>


// WEBPACK FOOTER //
// src/components/GameGif.vue